import React from "react"
import { Stack, Typography } from "@mui/material"
import { StyledPaper, StyledPaperTitle, StyledPaperLabel } from "../StyledSingleParseObjectComponents"

const PropertiesPanel = ({ title, icons, properties }) => {

    return (
        <StyledPaper>
            { title && (
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center">
                    <StyledPaperTitle>{title}</StyledPaperTitle>
                    { icons }
                </Stack>
            )}
            <Stack gap="16px">
                {
                    Object.keys(properties).map(propertyName => {
                        const propertyValue = properties[propertyName]
                        return (
                            <Stack direction="row" key={propertyName}>
                                <StyledPaperLabel>{propertyName}</StyledPaperLabel>
                                { propertyValue != null ? (
                                    <Typography >{propertyValue}</Typography>
                                ) : (
                                    <Typography sx={{ color: "#aaaaaa" }}> _ </Typography>
                                )}
                            </Stack>
                        )
                    })
                }
            </Stack>
        </StyledPaper>
    )
}

export default PropertiesPanel